import FlashBanner from '@square/glass-ui/components/banner-flash';
export default FlashBanner.extend({
  classNames: ['banner-flash--global', 'ecosystem-header-top-element']
});